import React, { useEffect, useState } from 'react';
import { Dropdown, PaperForm, Titulo, ContainerLogin, 
  InputText, ContainerInput, ButtonColor, ContainerButton, Loading, BackgroundLoadind } from './styles';
import { MenuItem, InputLabel, FormControl, Icon } from '@material-ui/core';
import GlobalStyles, { Container } from '../../styles/GlobalStyles';
import ApiGSI from '../../plugins/gsiApi';
import { useHistory } from "react-router-dom";
import {addHours} from 'date-fns'
import SnackBar from '../../components/SnackBar';

function Login() {
  const [dominios, setDominios] = useState([]);
  const [open, setOpen] = useState(false);
  const [openMsg, setOpenMsg] = useState(false);
  const [dominio, setDominio] = useState('');
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [msgError, setMsgError] = useState('');
  let history = useHistory();

  useEffect(() => {
    setOpen(true)
    ApiGSI.get(`${process.env.REACT_APP_BASEURL_GSI}/dominios`)
      .then(response => {
        if(response.status === 200) {
          setDominios(response.data.result);
        }
        setOpen(false);
      })
  }, [])

  const autenticar = () => {
    if(disableSearch() || open)
      return;
    
    setOpen(true)
    ApiGSI.post(`${process.env.REACT_APP_BASEURL_GSI}/Authenticate`, {dominio, loginAd: usuario, password: senha})
      .then(response => {
        if(response.status === 200) {
          ApiGSI.post(`${process.env.REACT_APP_BASEURL_GSI_AUTHORIZATION}`, { 
            usuarioID: response.data.result.usuarioID, 
            sistemaID: process.env.REACT_APP_SISTEMA_ID,
            ambienteID: process.env.REACT_APP_AMBIENTE_ID
          })
            .then(result => {
              if(result.status === 200) {
                setOpen(false);
                localStorage.setItem('Usuario', btoa(JSON.stringify({...result.data.result[0], expira: addHours(new Date(), 1)})))
                history.push('/');
              }
              else {
                setMsgError(result.data.errors.join('|'));
                setOpenMsg(true);
              }
            })
          }
          else {
            setMsgError(response.data.errors.join('|'));
            setOpenMsg(true);
          }
          setOpen(false);
      })
  }

  const disableSearch = () => {
    if (!usuario || !senha || !dominio)
      return true;

    return false;
  }

  return (
    <Container>
      <ContainerLogin>
        <PaperForm>
          <Titulo>ACERVO | PGE MS</Titulo>
          <FormControl>
            <InputLabel>Domínio</InputLabel>
            <Dropdown
              value={dominio}
              onChange={(e) => setDominio(e.target.value)}
              onKeyUp={(e) => e.keyCode === 13 ? autenticar(e) : null }
            >
              {dominios && dominios.map(dominio =>
                <MenuItem key={dominio.nome} value={dominio.nome}>{dominio.nome}</MenuItem>
              )}
            </Dropdown>
            <ContainerInput>
              <InputText 
                label="Usuário"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                onKeyUp={(e) => e.keyCode === 13 ? autenticar(e) : null }
              />
            </ContainerInput>
            <ContainerInput>
              <InputText
                label="Senha"
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                onKeyUp={(e) => e.keyCode === 13 ? autenticar(e) : null }
              />
            </ContainerInput>
            <ContainerButton>
              <ButtonColor
                bgColor="#e0e0e0"
                txtColor="#000"
                startIcon={<Icon>arrow_back</Icon>}
                onClick={() => history.push('/')}
              >
                Voltar
              </ButtonColor>
              <ButtonColor
                startIcon={<Icon>login</Icon>}
                disabled={disableSearch()}
                onClick={() => autenticar()}
              >
                Autenticar
              </ButtonColor>
            </ContainerButton>
          </FormControl>
        </PaperForm>
      </ContainerLogin>
      <BackgroundLoadind open={open}>
        <Loading />
      </BackgroundLoadind>
      <SnackBar open={openMsg} setOpen={() => setOpenMsg()} msgError={msgError} />
      <GlobalStyles />
    </Container>
  );
}

export default Login;